import styled from 'styled-components';

const DivThreadItemBody = styled.div`
  margin-top: 16px;
  overflow: hidden;
  display: -webkit-box;
  text-overflow: ellipsis;
  -webkit-line-clamp: 6;
  -webkit-box-orient: vertical;
`;

export default DivThreadItemBody;
